import { render, staticRenderFns } from "./CrearCasos.vue?vue&type=template&id=3ae3712c&"
import script from "./CrearCasos.vue?vue&type=script&lang=js&"
export * from "./CrearCasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports